<template>
  <div>
    <v-expansion-panels
        v-model='panel'
        multiple
    >
      <v-expansion-panel>
        <v-expansion-panel-header

        ><h3>Информация о товаре</h3></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <v-row>
            <v-col cols='12' md='4' sm='4'>
              <v-text-field :rules='[required]'
                            label='Товар'
                            item-value='Id'
                            readonly
                            v-model='item.Name'
                            outlined
                            :disabled='!input.isEdit'
                            dense
              />
            </v-col>
            <v-col cols='12' sm='4' md='4'>
              <v-text-field
                  label='Ставка НДС'
                  readonly
                  :rules='[maxRate,required]'
                  :disabled='!input.isEdit'
                  v-model='item.VATRate'
                  outlined
                  dense
              />
            </v-col>
            <v-col cols='12' md='4' sm='4'>
              <v-text-field
                  :rules='[rulesDensity,required]'
                  outlined
                  filled
                  v-model='item.Density'
                  :disabled='!input.isEdit'
                  label='Плотность'
                  type='number'
                  dense
                  @change='density'
              />
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <v-text-field
                  outlined
                  type='number'
                  :rules='[rulesTons,required]'
                  :disabled='!input.isEdit'
                  v-model='item.AmountInTonne'
                  label='Тонна'
                  dense
                  @input='tons'
              />
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <v-text-field
                  v-model='item.AmountInLitre'
                  @input='liter'
                  :rules='[rulesLiter ,required]'
                  :disabled='!input.isEdit'
                  outlined
                  dense
                  type='number'
                  label='Литр'
              />
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <div class='parent'>
                <v-text-field
                    v-model.lazy='item.GrossPricePerTonne'
                    outlined
                    :rules='[rulesPriceLiterOrTons,required]'
                    type='number'
                    readonly
                    dense
                    :disabled='!input.isEdit'
                    @input='priceTons'
                    label='Цена за тонну'
                />
              </div>
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <div class='parent'>
                <v-text-field
                    v-model='item.GrossPricePerLitre'
                    outlined
                    readonly
                    :rules='[rulesPriceLiterOrTons,required]'
                    type='number'
                    dense
                    :disabled='!input.isEdit'
                    @input='priceLiter'
                    label='Цена за литр'
                >
                </v-text-field>
                <v-checkbox class='absalute'
                            v-model='item.ShowAmountInLitre'
                            hide-details
                            :disabled='!input.isEdit'
                            outlined
                            dense
                ></v-checkbox>
              </div>
            </v-col>

          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>

    </v-expansion-panels>
    <v-row>
      <v-col v-for='(result,index) of resultList' :key='index'
             cols='12' :md='result.title.style.md' :sm='result.title.style.sm'
      >
        <v-subheader class='sectionTitle'>
          {{ result.title.name }}
        </v-subheader>
        <v-divider></v-divider>
        <v-row>
          <v-col v-for='(obj,index) of result.items' :key='index'
                 cols='12' :md='obj.style.md' :sm='obj.style.sm'>
            <v-list-item tow-line>
              <v-list-item-content>
                <v-list-item-title :class='obj.class' class='itemValue'>
                  {{ info(obj) }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ obj.subtitle }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>


<script>

import { ProductCalc } from '@/utils/functions/Product'
import { num2str } from '@/utils/functions/MoneyFromString'
import {
  excise,
  priceClearNdsPrices,
  priceClearPrice,
  priceClearPrices,
  totalNds,
  totalPrice, totalPrice2,
  vatRate,
  density, liter, price, ton
} from '@/utils/filters/oil'

export default {
  props: {
    input: Object,
    isTTN: Boolean,
    contract: Object,
    item: Object,
    getProduct: Function
  },
  data: () => ({
    products: [],
    dataContract: {},
    panel: [0],
    required: value => {
      if (typeof value === 'boolean' || typeof value === 'number')
        return true
      else {
        return !!value || 'Поле обязательно для ввода'
      }
    },
    maxRate(maxRate) {
      const number = parseInt(maxRate)
      // const isFloat = number.toString().includes('.')
      // console.log(isFloat)
      // if (isFloat) return 'Разрешены Только целые числа'
      if (isNaN(number)) return 'Разрешены Только числа от 1 до 100'
      return (number >= 0 && number <= 100) || 'Разрешены Только числа от 1 до 100'
    },
    rulesDensity(density) {
      const number = parseFloat(density)
      if (isNaN(number)) return 'Разрешены Только числа'
      const numberStr = number.toString()
      const length = numberStr.length
      if (length > 5 && numberStr.includes('.')) return 'Максимальная длина после точки не может превышать 3 цифры'
      return (number <= 1 && number > 0) || 'Разрешенный числа больше нуля до одного'
    },
    rulesLiter(liter) {
      const number = parseFloat(liter)
      if (isNaN(number)) return 'Разрешены Только числа'
      const isFloat = liter.toString().includes('.')
      if (isFloat) return 'Разрешены Только целые числа'
      return true
    },
    rulesPriceLiterOrTons(priceLiterOrTons) {
      const number = parseFloat(priceLiterOrTons)
      if (isNaN(number)) return 'Разрешены Только числа'
      const strNumber = number.toString()
      const isFloat = strNumber.includes('.')
      if (isFloat) {
        const length = strNumber.split('.')[1].toString().length
        return length <= 2 || 'Максимальная длина после точки не может превышать 2 цифры'
      }
      return true
    },
    rulesTons(priceTons) {
      const number = parseFloat(priceTons)
      if (isNaN(number)) return 'Разрешены Только числа'
      const strNumber = number.toString()
      const isFloat = strNumber.includes('.')
      if (isFloat) {
        const length = strNumber.split('.')[1].toString().length
        return length <= 4 || 'Максимальная длина после точки не может превышать 4 цифры'
      }
      return true
    },
    resultList: [
      {
        title: { name: 'Товар', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: 'Название',
            name: 'Name',
            action: null,
            style: { md: '6', sm: '6' }
          },
          {
            subtitle: 'Плотность',
            name: 'Density',
            action: density,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'Количество', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: 'Кол-во в тоннах',
            name: 'AmountInTonne',
            action: ton,
            style: { md: '6', sm: '6' }
          },
          {
            subtitle: 'Кол-во в литрах',
            name: 'AmountInLitre',
            action: liter,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'Цена', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: 'За тонну',
            name: 'GrossPricePerTonne',
            action: price,
            style: { md: '6', sm: '6' }
          },
          {
            subtitle: 'За литр',
            name: 'GrossPricePerLitre',
            action: price,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'Себестоимость', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: 'За тонну без АКЦИЗ и НДС',
            name: 'GrossPricePerTonne',
            action: priceClearPrice,
            isObject: true,
            style: { md: '6', sm: '6' }
          },
          {
            subtitle: 'Стоимость поставки без АКЦИЗ и НДС',
            name: 'GrossPricePerTonne',
            action: priceClearPrices,
            isObject: true,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'Акциз', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: 'Ставка',
            name: 'tmpExcise',
            action: price,
            style: { md: '6', sm: '6' }
          },
          {
            subtitle: 'Сумма',
            name: 'Excise',
            action: excise,
            isObject: true,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'Стоимость с Акцизом', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: 'Сумма',
            name: 'AmountInTonne',
            action: priceClearNdsPrices,
            isObject: true,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'Общая стоимость поставки', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: '',
            name: 'GrossPricePerTonne',
            action: totalPrice,
            class: 'totalPrice',
            isSpectrial: true,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'НДС', style: { md: '6', sm: '6' } },
        items: [
          {
            subtitle: 'Ставка',
            name: 'VATRate',
            action: vatRate,
            isObject: true,
            style: { md: '6', sm: '6' }
          },
          {
            subtitle: 'Сумма',
            name: 'GrossPricePerTonne',
            action: totalNds,
            isObject: true,
            style: { md: '6', sm: '6' }
          }
        ]
      },
      {
        title: { name: 'Сумма с прописью', style: { md: '12', sm: '12' } },
        items: [
          {
            subtitle: '',
            name: 'GrossPricePerTonne',
            action: totalPrice,
            prop: true,
            style: { md: '12', sm: '12' }
          }
        ]
      }
    ]
  }),
  async created() {
    this.dataContract = this.contract
  },
  computed: {
    thisContract() {
      return this.contract
    },
    canSetLiter() {
      const { AmountInTonne, AmountInLitre, GrossPricePerTonne, Density } = this.item
      return !isNaN(parseFloat(AmountInTonne)) &&
          !isNaN(parseFloat(AmountInLitre)) &&
          !isNaN(parseFloat(GrossPricePerTonne)) &&
          !isNaN(parseFloat(Density))
    }
  },
  methods: {
    info(obj) {
      if (obj.action === null) {
        return this.item[obj.name]
      }
      if (obj.isSpectrial) {
        return obj.action(this.item)
      }
      if (obj.isObject) {
        return obj.action(this.item)
      }
      if (obj.prop) {
        const price = ProductCalc.TotalPrice(this.item)
        this.item.TotalPriceInText = num2str(price)
        return this.item.TotalPriceInText
      }
      return obj.action(this.item[obj.name])
    },
    density(density) {
      if (density > 0 && density < 1) {
        ProductCalc.density(this.item)
        this.item.AmountInTonne = ''
        this.item.AmountInLitre = ''
        this.item.GrossPricePerLitre = ''
      } else {
        this.item.AmountInTonne = ''
        this.item.AmountInLitre = ''
        this.item.NetPricePerTonne = ''
        this.item.PricePerTonneNoVAT = ''
        this.item.VATPerTonne = ''
      }
    },
    tons() {
      ProductCalc.setTons(this.item)
      if (this.canSetLiter)
        this.priceTons()
    },
    liter() {
      ProductCalc.setLiter(this.item)
      if (this.canSetLiter)
        this.priceTons()
    },
    priceLiter() {
      ProductCalc.setPriceLiter(this.item)
    },
    priceTons() {
      ProductCalc.setPriceTons(this.item)
    }
  }
}
</script>

<style>
.totalPrice {
  font-weight: bold;
  font-size: 25px;
}

.parent {
  position: relative;
}

.absalute {
  position: absolute;
  left: 100%;
  right: 0;
  top: -12px;
}
</style>